/** Keep in sync with backend/src/config/landingDefaults.js (fallback when DB is empty). */
export const DEFAULT_LANDING = {
  nav: {
    brandName: 'RotationStreet',
    tagline: '',
    loginLabel: 'Log In',
    ctaLabel: 'Get Started',
  },
  hero: {
    badge: "Now Open for Global LPs & China's Startups",
    titleLine1: 'Connect Global Capital with',
    titleHighlight: 'China Assets',
    titleLine2: 'China Assets',
    subtitle:
      "The AI-powered platform that bridges China's private asset with global investors (LP). Secure custody, multilingual support, end-to-end deal flow.",
    gpCta: "I'm a Startup — Publish Projects",
    lpCta: "I'm an LP — Discover Deals",
  },
  stats: {
    items: [
      { value: '25,000+', label: 'Global LP Decision Makers' },
      { value: '47', label: 'Active Deals' },
      { value: '$18.2bn+', label: 'Escrowed' },
    ],
  },
  featuresSection: {
    title: 'Everything You Need to Close Cross-Border Deals',
    description: 'Six interconnected modules working seamlessly together — from first contact to deals done.',
  },
  featureTabs: [
    {
      id: 'deal',
      icon: 'deal',
      title: 'Post a Deal',
      sub: 'Create & publish',
      heading: 'Post a Deal',
      subheading: 'Create & publish your fund or asset',
      body: 'Publish your fund or asset deal with key details — target size, strategy, geography, and timeline. Matched LPs can discover opportunities through the platform marketplace.',
      tags: ['One-click publish', 'Deal lifecycle', 'Smart LP matching', 'Deal analytics dashboard'],
    },
    {
      id: 'email',
      icon: 'email',
      title: 'Email',
      sub: 'Inbox & Campaign',
      heading: 'Email',
      subheading: 'Full-featured email communication',
      body: 'Email campaigns with admin approval, delivery tracking, and platform mailbox. DeepSeek translation supports cross-border communication when configured.',
      tags: ['Inbox & Replies', 'Bulk Campaign', 'Auto-translation', 'Delivery tracking'],
    },
    {
      id: 'doc',
      icon: 'files',
      title: 'Files',
      sub: 'DeepSeek translation',
      heading: 'Files',
      subheading: 'AI-powered document management',
      body: 'Secure file storage with deal-level access control and optional AI translation for due diligence materials.',
      tags: ['AI classification', 'Access control', 'Version control'],
    },
    {
      id: 'meeting',
      icon: 'meeting',
      title: 'Meeting',
      sub: 'Live translation',
      heading: 'Meeting',
      subheading: 'Video conferencing with live translation',
      body: 'Schedule meetings with deal participants. Integrates with Tencent Meeting when configured, otherwise platform scheduling links.',
      tags: ['HD video', 'Live translation', 'Calendar sync'],
    },
    {
      id: 'im',
      icon: 'chat',
      title: 'Chat',
      sub: 'Real-time messaging',
      heading: 'Chat',
      subheading: 'Real-time communication across languages',
      body: 'One-on-one chat across deal participants with optional message translation and contact quota by membership tier.',
      tags: ['Instant delivery', 'Unread tracking', 'Contacts directory'],
    },
    {
      id: 'collab',
      icon: 'collaborate',
      title: 'Collaboration Hub',
      sub: 'Project timeline',
      heading: 'Collaboration Hub',
      subheading: 'Track every step from intent to closing',
      body: 'Deal progress tracker, stage tasks, document list, and activity timeline — all driven by live deal data in your account.',
      tags: ['Timeline view', 'Task tracking', 'Activity feed'],
    },
  ],
  howItWorks: {
    title: 'From First Contact to Deal Closed in 4 Steps',
    steps: [
      { title: 'Publish & Translate', text: 'GP uploads project documents → platform stores and optionally translates materials for global LPs' },
      { title: 'Reach Global LPs', text: 'Approved email campaigns and marketplace browse → LP expresses interest → NDA and diligence workflow' },
      { title: 'Due Diligence', text: 'Meetings, chat, and file review with translation support. Progress tracked on the deal timeline.' },
      { title: 'Fund & Close', text: 'Escrow wire records submitted and confirmed by admin → Deal advances to close' },
    ],
  },
  cta: {
    title: 'Ready to Connect with Global Capital?',
    description: 'Join RotationStreet today. Register with your work email and connect with verified GP/LP members.',
    buttonLabel: 'Get Started →',
  },
  footer: {
    brandName: 'RotationStreet',
    copyright: '© 2026 Rotation Street. All rights reserved.',
    tagline: 'The platform connecting Chinese GPs with global LPs. Secure, transparent, multilingual.',
    madeWith: 'Made with 🌏 for China × Global Capital',
  },
}

export function mergeLandingContent(stored) {
  const base = DEFAULT_LANDING
  if (!stored) return { ...base }
  const merged = {
    ...base,
    ...stored,
    nav: { ...base.nav, ...(stored.nav || {}) },
    hero: { ...base.hero, ...(stored.hero || {}) },
    stats: {
      ...base.stats,
      ...(stored.stats || {}),
      items: stored.stats?.items?.length ? stored.stats.items : base.stats.items,
    },
    featuresSection: { ...base.featuresSection, ...(stored.featuresSection || {}) },
    featureTabs: stored.featureTabs?.length ? stored.featureTabs : base.featureTabs,
    howItWorks: {
      ...base.howItWorks,
      ...(stored.howItWorks || {}),
      steps: stored.howItWorks?.steps?.length ? stored.howItWorks.steps : base.howItWorks.steps,
    },
    cta: { ...base.cta, ...(stored.cta || {}) },
    footer: { ...base.footer, ...(stored.footer || {}) },
  }
  return merged
}
